import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { HEADER } from "../../utils/constant";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ThreeDots } from 'react-loader-spinner';

const SlickSlider = ({ header, slides = [], swiperConfig = {}, className = "", loader }) => {
  const validSlides = slides.filter((s) => s !== null);
  const settings = {
    dots: false,
    arrows: false,
    infinite: validSlides.length > 2,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    pauseOnHover: false,
    pauseOnFocus: false,
    ...swiperConfig,
  };

  return (
    <section className={`slider ${className}`}>
      <div className="slider-header">
        <h4>
          {HEADER === header ? "Start Earning Points" : "Rewards"}
        </h4>
        {HEADER === header ? "" : <Link to="/reward">View All Rewards</Link>}
      </div>

      {
        loader ? <ThreeDots
          height="50"
          width="50"
          radius="9"
          color="#7334C7"
          ariaLabel="three-dots-loading"
          wrapperStyle={{ margin: '20px', justifyContent: 'center' }}
          wrapperClass=""
          visible={true}
        /> : <Slider {...settings}>
          {slides
            .filter((slide) => slide !== null)
            .map((slide, index) => (
              <div key={index} className="slick-slide">
                {slide}
              </div>
            ))}
        </Slider>
      }

    </section>
  );
};

export default SlickSlider;
